var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<gg-tabs active=\"vm.activeChartsTab\" hide-default-panels=\"true\"><gg-tab name=\"demographics\" label=\"{{'demographics' | translate }}\" custom-classes=\"big-tabs border-tl-radius-5 u-1/3 capitalize\" class=\"tableize__cell u-inline-block\"></gg-tab><gg-tab name=\"activity\" label=\"{{'activity' | translate }}\" custom-classes=\"big-tabs u-1/3 capitalize\" class=\"tableize__cell u-inline-block\"></gg-tab><gg-tab name=\"payment\" label=\"Monetization\" custom-classes=\"big-tabs border-tr-radius-5 u-1/3 capitalize\" class=\"tableize__cell u-inline-block\"></gg-tab></gg-tabs><explore-trend-widgets-ng1 ng-if=\"vm.visualizationMode=='trend'\" active-charts-tab=\"vm.activeChartsTab\"></explore-trend-widgets-ng1><explore-snapshot-widgets-ng2-downgraded ng-if=\"vm.visualizationMode=='snapshot'\" [active-charts-tab]=\"vm.activeChartsTab\" [widgets-data]=\"vm.widgetsData\" [is-no-group-loaded-and-pristine-filters]=\"vm.isNoGroupLoadedAndPristineFilters\"></explore-snapshot-widgets-ng2-downgraded>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/explore/exploreWidgetTabsNg1.jade
 ** module id = 714
 ** module chunks = 0
 **/